import React from "react"

// Components Global
import { LayoutsDesignDisplay } from '../../../LayoutsDesign'

const ContentPageGroupDisplay = (props) => {
  const { business, setting, site, pages, pageCurrent, singlePageData, templateData } = props.datas

  return (
    <LayoutsDesignDisplay
      {...props}
      display
      action={{
        params: {
          business,
          setting,
          site,
          pages,
          data: singlePageData ? singlePageData : site,
          pageCurrent,
          templateData,
          _id: singlePageData ? singlePageData._id : site._id,
        }
      }}
    />
  )
}

export default ContentPageGroupDisplay
